// extracted by mini-css-extract-plugin
export default {"dropdown-width":"localization-selector_dropdown-width__M-IgK"};